import { isHidden } from '../utils/element';
var calculateDepthForNode = function (node) {
    if (isHidden(node)) {
        return Infinity;
    }
    var depth = 0;
    var parent = node.parentNode;
    while (parent) {
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};
export { calculateDepthForNode };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@juggle/resize-observer/lib/algorithms/calculateDepthForNode.js
// module id = 112
// module chunks = 0